import { Type, type Static } from "@sinclair/typebox";
import { UuidSchema } from "./identifiers.ts";

export const DOCUMENT_ORGANIZATION_SCHEMA_VERSION = "1.0" as const;
export const DOCUMENT_VIEW_RESULT_MAX_LIMIT = 100;

export const DocumentTimestampSchema = Type.String({ format: "date-time" });
export const DocumentDateSchema = Type.String({
  format: "date",
  pattern: "^\\d{4}-\\d{2}-\\d{2}$"
});
export const DocumentTimeZoneSchema = Type.String({
  minLength: 1,
  maxLength: 128,
  pattern: "^(UTC|[A-Za-z_]+(?:/[A-Za-z0-9_+.-]+)+)$"
});

export const DocumentCollectionKindSchema = Type.Union([
  Type.Literal("file_space_default"),
  Type.Literal("explicit")
]);
export type DocumentCollectionKindV1 = Static<typeof DocumentCollectionKindSchema>;

export const DocumentCollectionSchema = Type.Object(
  {
    schemaVersion: Type.Literal(DOCUMENT_ORGANIZATION_SCHEMA_VERSION),
    collectionId: UuidSchema,
    fileSpaceId: UuidSchema,
    name: Type.String({ minLength: 1, maxLength: 256 }),
    kind: DocumentCollectionKindSchema,
    createdByPrincipalId: UuidSchema,
    revision: Type.Integer({ minimum: 0 }),
    createdAt: DocumentTimestampSchema,
    updatedAt: DocumentTimestampSchema
  },
  { additionalProperties: false }
);
export type DocumentCollectionV1 = Static<typeof DocumentCollectionSchema>;

export const DocumentCollectionMembershipSchema = Type.Object(
  {
    schemaVersion: Type.Literal(DOCUMENT_ORGANIZATION_SCHEMA_VERSION),
    fileSpaceId: UuidSchema,
    collectionId: UuidSchema,
    documentId: UuidSchema,
    addedByPrincipalId: UuidSchema,
    createdAt: DocumentTimestampSchema
  },
  { additionalProperties: false }
);
export type DocumentCollectionMembershipV1 = Static<typeof DocumentCollectionMembershipSchema>;

export const DocumentCollectionCreateInputSchema = Type.Object(
  { name: Type.String({ minLength: 1, maxLength: 256 }) },
  { additionalProperties: false }
);
export type DocumentCollectionCreateInputV1 = Static<typeof DocumentCollectionCreateInputSchema>;

export const DocumentCollectionUpdateInputSchema = Type.Object(
  {
    name: Type.String({ minLength: 1, maxLength: 256 }),
    expectedRevision: Type.Integer({ minimum: 0 })
  },
  { additionalProperties: false }
);
export type DocumentCollectionUpdateInputV1 = Static<typeof DocumentCollectionUpdateInputSchema>;
